import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d5dc8d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5d5dc8d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5dc8d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5dc8d4')) {
      api.createRecord('5d5dc8d4', component.options)
    } else {
      api.reload('5d5dc8d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d5dc8d4&scoped=true", function () {
      api.rerender('5d5dc8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backNoticeTemplate/index.vue"
export default component.exports